import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "./firebase";

export const signUpAPI = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const loginAPI = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signInWithGoogleAPI = () => {
  const provider = new GoogleAuthProvider();
  return signInWithPopup(auth, provider);
};

export const logoutAPI = () => {
  return auth.signOut();
};
